var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0H11.15H8.5H2.85C1.25 0 0 1.3 0 2.85V17.15C0 18.75 1.3 20 2.85 20H11.15C12.75 20 14 18.7 14 17.15V5H18V2.5C18 1.1 16.9 0 15.5 0ZM13.4 1.15C13.15 1.5 13 2 13 2.5V2.85V5V17.15C13 18.15 12.15 19 11.15 19H2.85C1.85 19 1 18.15 1 17.15V2.85C1 1.85 1.85 1 2.85 1H8.5H11.15H13.3H13.5C13.5 1.05 13.45 1.1 13.4 1.15ZM14 2.85V4H17V2.5C17 1.65 16.35 1 15.5 1C14.65 1 14 1.65 14 2.5V2.85ZM11.5 5.5C11.5 5.8 11.3 6 11 6H3C2.7 6 2.5 5.8 2.5 5.5C2.5 5.2 2.7 5 3 5H11C11.3 5 11.5 5.2 11.5 5.5ZM8 12C8.3 12 8.5 11.8 8.5 11.5C8.5 11.2 8.3 11 8 11H3C2.7 11 2.5 11.2 2.5 11.5C2.5 11.8 2.7 12 3 12H8ZM11.5 9.5C11.5 9.8 11.3 10 11 10H3C2.7 10 2.5 9.8 2.5 9.5C2.5 9.2 2.7 9 3 9H11C11.3 9 11.5 9.2 11.5 9.5ZM11 8C11.3 8 11.5 7.8 11.5 7.5C11.5 7.2 11.3 7 11 7H3C2.7 7 2.5 7.2 2.5 7.5C2.5 7.8 2.7 8 3 8H11Z",
    fill: "#582483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.4d8d58ffe5a12d52060d4a422ac57c51.svg";
export { ForwardRef as ReactComponent };